export const GATEWAY_PROFILE_CODES = [
  'ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3',
  'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4',
  'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2',
  'AUD3', 'INT', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1',
  'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1',
  'GM01'
] as const;

export type ProfileCode = typeof GATEWAY_PROFILE_CODES[number];

export const CUSTOMER_PROFILE_CODES: ProfileCode[] = ['CUS1', 'CUS2', 'CUS3'];

export const NON_CUSTOMER_PROFILE_CODES: ProfileCode[] = GATEWAY_PROFILE_CODES.filter(
  code => !CUSTOMER_PROFILE_CODES.includes(code)
);

export const QUALITY_MANAGER_PROFILE_CODE: ProfileCode = 'QM01';

export const INTRODUCER_PROFILE_CODE: ProfileCode = 'INT';

export const NON_INTRODUCER_PROFILE_CODES: ProfileCode[] = GATEWAY_PROFILE_CODES.filter(
  code => code !== INTRODUCER_PROFILE_CODE
);

export const INTERNAL_PROFILE_CODES: ProfileCode[] = NON_CUSTOMER_PROFILE_CODES.filter(
  code => code !== INTRODUCER_PROFILE_CODE
);

export const RISK_PROFILE_CODES: ProfileCode[] = [
  'ADM1', 'QM01', 'CTO1', 'COO1', 'PRJ6', 'MAN1', 'MAN2', 'TE6+',
  'SAL1', 'SAL2', 'SAL3', 'DIR3', 'DIR4',
  'TES1', 'TES2', 'TES3', 'TES5', 'TES6',
  'AUD1', 'AUD2', 'AUD3', 'MAT1', 'MAT4', 'HR1', 'HR2', 'HR3'
];

const INTRODUCER_LIST_PROFILE_CODES: ProfileCode[] =
  ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'INT', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'];

const INTRODUCER_LIST_EDITOR_PROFILE_CODES: ProfileCode[] =
  INTRODUCER_LIST_PROFILE_CODES.filter(code => code !== INTRODUCER_PROFILE_CODE);

const REGULATORS_PROFILE_CODES: ProfileCode[] = INTERNAL_PROFILE_CODES;

const REGULATORS_MANAGE_PROFILE_CODES: ProfileCode[] = ['ADM1', 'CTO1', 'COO1', 'QM01', 'CCO'];

export type AccessKey =
  | 'HOME'
  | 'CLIENTS_LIST'
  | 'CLIENTS_DETAILS'
  | 'CLIENTS_SETTINGS'
  | 'REQUESTS_LIST'
  | 'REQUESTS_SETTINGS'
  | 'REQUESTS_TRAFFIC_LIGHTS'
  | 'PROPOSALS_LIST'
  | 'PROPOSALS_ARCHIVED'
  | 'PROPOSALS_SETTINGS'
  | 'PROJECTS_LIST'
  | 'PROJECTS_CERTIFICATES_LIST'
  | 'PROJECTS_SETTINGS'
  | 'GS_USERS'
  | 'TECH_UPLOAD_DOCS_VIDEO'
  | 'TECH_FILE_MANAGER'
  | 'SHARED_RESOURCES_FILE_MANAGER'
  | 'IT_FILE_MANAGER'
  | 'IT_ANTIVIRUS_LOG'
  | 'COMPANY_OPERATION_FILE_MANAGER'
  | 'COMPLIANCE_FILE_MANAGER'
  | 'COMPLAINT_LIST'
  | 'SALES_PROPOSAL'
  | 'SALES_PROJECT'
  | 'SALES_TO_DO_LIST'
  | 'SALES_CONTACT_MANAGEMENT'
  | 'SALES_FILE_MANAGER'
  | 'MANAGEMENT_FILE_MANAGER'
  | 'INTRODUCER_LIST'
  | 'INTRODUCER_REVENUE_LIST'
  | 'INTRODUCER_CLIENTS'
  | 'REGULATORS_LIST'
  | 'FINANCE_INVOICES'
  | 'FINANCE_REPORTS'
  | 'FINANCE_FILE_MANAGER'
  | 'FINANCE_PROJECT_PAYMENTS_REPORT'
  | 'PROJECTS_FINANCE'
  | 'GENERAL_SETTINGS'
  | 'GS_CATEGORY'
  | 'GS_COMPANIES'
  | 'GS_JURISDICTION'
  | 'GS_ITEM_TYPE'
  | 'GS_ITEM_PRODUCTS'
  | 'GS_LAW'
  | 'GS_REGULATION'
  | 'GS_ITEMS'
  | 'GS_DEPARTMENTS'
  | 'GS_ACCESS_CONTROL_LIST'
  | 'IT'
  | 'MARKETING'
  | 'HR'
  | 'HR_EMPLOYEES'
  | 'HR_DAILY_REPORT'
  | 'HR_RANKING_STAFF'
  | 'HR_APPRAISAL'
  | 'HR_TRAINING'
  | 'HR_SPECIALISATION'
  | 'HR_SETTINGS'
  | 'HR_FILE_MANAGER'
  | 'QUALITY_MANAGER_RISK_MANAGEMENT'
  | 'QUALITY_MANAGER_RISK_MANAGEMENT_GROUP'
  | 'QUALITY_MANAGER_RISKS'
  | 'QUALITY_MANAGER_MEETING_MINUTES'
  | 'QUALITY_MANAGER_SETTINGS_GROUP'
  | 'QUALITY_MANAGER_SETTINGS_RISK_TIME_FRAME'
  | 'QUALITY_MANAGER_AP_PREVENTIVE_ACTIONS'
  | 'QUALITY_MANAGER_CAP_CORRECTIVE_ACTIONS'
  | 'QUALITY_MANAGER_INSPECTOR_TESTER'
  | 'QUALITY_MANAGER_MONITORING_JURISD_CHANGES'
  | 'QUALITY_MANAGER_ACTIVITIES_PLANNING'
  | 'QUALITY_MANAGER_COMPANY_DOCS'
  | 'QUALITY_MANAGER_CUSTOMER_SURVEY'
  | 'QUALITY_MANAGER_INTERNAL_AUDIT'
  | 'QUALITY_MANAGER_SETTINGS'
  | 'QUALITY_MANAGER_FILE_MANAGER'
  | 'MARKETING_REPORTS'
  | 'MARKETING_CAMPAIGNS'
  | 'MARKETING_HISTORY'
  | 'MARKETING_SETTINGS'
  | 'MARKETING_FILE_MANAGER'
  | 'OFFICE_OPERATION_MISSION_TRAVELS'
  | 'OFFICE_OPERATION_RANKING_STAFF_CUSTOMERS'
  | 'OFFICE_OPERATION_TRAVEL_EXPENCES'
  | 'FILE_MANAGER_AUDIT';

export type AccessAction = 'view' | 'modify' | 'delete' | 'impersonate' | 'mfaManage' | 'createFolder' | 'export';

export type FeatureActionKey =
  | 'CLIENTS_LIST'
  | 'CLIENTS_SETTINGS_CLIENT_TYPES'
  | 'REQUESTS_LIST'
  | 'REQUESTS_SETTINGS_CATEGORIES'
  | 'PROPOSALS_LIST'
  | 'PROPOSALS_SETTINGS_PROPOSAL_STEPS'
  | 'PROPOSALS_SETTINGS_PAYMENT_TERMS'
  | 'PROPOSALS_STATUS_SALES'
  | 'PROPOSALS_STATUS_OVERDISCOUNT_APPROVAL'
  | 'PROPOSALS_STATUS_TECH_APPROVAL'
  | 'PROPOSALS_STATUS_SALES_OVERALL_CHECK'
  | 'PROPOSALS_STATUS_PENDING_CLIENT'
  | 'PROPOSALS_SWITCH_VERIFIED'
  | 'PROPOSALS_SWITCH_VERIFIED_TECH'
  | 'PROPOSALS_DETAIL_ACTIONS'
  | 'PROJECTS_LIST'
  | 'PROJECTS_SETTINGS_CHECKLIST'
  | 'PROJECTS_SETTINGS_TESTLIST'
  | 'PROJECTS_TESTLIST_MODIFY'
  | 'PROJECTS_TESTLIST_REVIEW_CHECKBOX'
  | 'PROJECTS_CERTIFICATE_ACTIVE_TOGGLE'
  | 'PROJECTS_CERTIFICATE_UPLOAD'
  | 'PROJECTS_CERTIFICATE_HASH_CODE'
  | 'PROJECTS_CERTIFICATE_INACTIVE_TABLE'
  | 'PROJECTS_CERTIFICATE_MANAGE_ROW'
  | 'PROJECTS_TEAM_SEND_APPROVAL'
  | 'HR_EMPLOYEES'
  | 'HR_SPECIALISATION'
  | 'MARKETING_CAMPAIGNS'
  | 'GS_CATEGORY'
  | 'GS_REGULATION'
  | 'GS_LAW'
  | 'GS_JURISDICTION'
  | 'GS_ITEMS'
  | 'GS_ITEM_TYPE'
  | 'GS_USERS'
  | 'GS_COMPANIES'
  | 'GS_DEPARTMENTS'
  | 'INTRODUCER_LIST'
  | 'INTRODUCER_SELECT_FILTER'
  | 'PROJECTS_CLIENTS_REQUESTED_DOCUMENTS'
  | 'CLIENTS_DETAILS_PANELS'
  | 'CUSTOMERS_DOCUMENTS_UPLOAD'
  | 'CUSTOMERS_DOCUMENTS_CONFIRMED_COLUMN'
  | 'CUSTOMERS_DOCUMENTS_SEND_REMINDER'
  | 'PROJECTS_SUMMARY_REVIEWED_CHECKBOX'
  | 'IT_FILE_MANAGER'
  | 'HR_FILE_MANAGER'
  | 'MANAGEMENT_FILE_MANAGER'
  | 'FINANCE_FILE_MANAGER'
  | 'SALES_FILE_MANAGER'
  | 'TECH_FILE_MANAGER'
  | 'COMPLIANCE_FILE_MANAGER'
  | 'SHARED_RESOURCES_FILE_MANAGER'
  | 'COMPANY_OPERATIONS_FILE_MANAGER'
  | 'QUALITY_MANAGEMENT_FILE_MANAGER'
  | 'MARKETING_FILE_MANAGER'
  | 'PROJECTS_TAB_SUMMARY'
  | 'PROJECTS_TAB_DOCUMENTS_REQUESTED_TO_CLIENT'
  | 'PROJECTS_TAB_TEAM'
  | 'PROJECTS_TAB_TESTLIST'
  | 'PROJECTS_TAB_ISSUES'
  | 'PROJECTS_TAB_CERTIFICATE'
  | 'PROJECTS_SUMMARY_INSPECTORS'
  | 'PROJECTS_SUMMARY_NOTES'
  | 'PROJECTS_SUMMARY_FIELDS_EDIT'
  | 'PROJECTS_SUMMARY_PROGRESS_NOTE'
  | 'PROJECTS_CLIENTS_REQUESTED_DOCUMENTS_CREATE'
  | 'PROJECTS_CLIENTS_REQUESTED_DOCUMENTS_SEND_REQUEST'
  | 'PROJECTS_TEAM_AVAILABLE_STAFF'
  | 'PROJECTS_TEAM_ASSIGNMENT_EDIT'
  | 'PROJECTS_TEAM_MOOD_BUTTON'
  | 'PROJECTS_TESTLIST_REVIEW_CHECKBOX_CONFIRM'
  | 'PROJECTS_TESTLIST_EVIDENCE_UPLOAD'
  | 'PROJECTS_TESTLIST_ROUND_FULL_ACCESS'
  | 'PROJECTS_ISSUES_DELETE'
  | 'PROJECTS_ISSUES_VERIFIED_CHECKBOX'
  | 'PROJECTS_ISSUES_STATUS_EDIT'
  | 'PROJECTS_ISSUES_PRIORITY_EDIT'
  | 'PROJECTS_ACCORDION_SAVE_BUTTON'
  | 'PROJECTS_FINANCE'
  | 'FINANCE_PROJECT_PAYMENTS_REPORT'
  | 'REGULATORS_LIST'
  | 'QUALITY_MANAGEMENT_ACTIVITIES_PLANNING'
  | 'QUALITY_MANAGEMENT_COMPANY_DOCUMENTS'
  | 'QUALITY_MANAGEMENT_RISKS'
  | 'QUALITY_MANAGEMENT_MEETING_MINUTES'
  | 'QUALITY_MANAGEMENT_SETTINGS_RISK_TIME_FRAMES'
  | 'QUALITY_MANAGEMENT_SETTINGS_DOCUMENT_GROUPS';

const LEGACY_PROFILE_TO_GATEWAY: Record<string, ProfileCode> = {
  ADMINISTRATOR: 'ADM1',
  CTO: 'CTO1',
  QUALITY_MANAGER: 'QM01',
  SENIOR_TESTER: 'TES1',
  CUSTOMER_OWNER: 'CUS1',
  CUSTOMER_PM: 'CUS2',
  CUSTOMER_ADMINISTRATION: 'CUS3',
  SALES_DIRECTOR: 'SAL1',
  INSPECTOR_AUDITOR: 'AUD1',
  INSPECTOR_ACCESS: 'AUD2',
  JUNIOR_TESTER: 'TES2',
  MATHEMATICIAN: 'MAT1',
  HR_MANAGER: 'HR1'
};

const mergeProfileCodes = (...lists: ProfileCode[][]): ProfileCode[] =>
  Array.from(new Set(lists.flat()));

const FINANCE_VIEW_PROFILE_CODES: ProfileCode[] = ['ADM1', 'QM01', 'CFO1', 'CCO'];

const FINANCE_MANAGE_PROFILE_CODES: ProfileCode[] = ['ADM1'];

const QUALITY_MANAGER_RISK_MANAGEMENT_PROFILE_CODES: ProfileCode[] =
  ['ADM1', 'CTO1', 'COO1', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'];

const QUALITY_MANAGER_SETTINGS_PROFILE_CODES: ProfileCode[] =
  ['ADM1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01', 'CTO1', 'COO1', 'PRJ6'];

export const FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES: ProfileCode[] = ['ADM1', 'QM01', 'CTO1', 'HR1', 'HR2', 'HR3'];

const GATEWAY_PROFILES_BY_KEY: Partial<Record<AccessKey, ProfileCode[]>> = {
  HOME: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
  CLIENTS_LIST: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  CLIENTS_DETAILS: ['CUS1', 'CUS2', 'CUS3'],
  CLIENTS_SETTINGS: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01', 'OFF5', 'QM01', 'CTO1', 'COO1', 'DIR3', 'DIR4', 'PRJ6'],
  REQUESTS_LIST: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
  REQUESTS_SETTINGS: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01', 'CTO1', 'COO1'],
  REQUESTS_TRAFFIC_LIGHTS: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  PROPOSALS_LIST: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
  PROPOSALS_SETTINGS: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01', 'CTO1', 'COO1'],
  PROJECTS_LIST: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  PROJECTS_SETTINGS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  TECH_UPLOAD_DOCS_VIDEO: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  TECH_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SHARED_RESOURCES_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  IT_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  IT_ANTIVIRUS_LOG: ['ADM1', 'CTO1', 'COO1', 'QM01'],
  COMPANY_OPERATION_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  COMPLIANCE_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  COMPLAINT_LIST: ['ADM1', 'CTO1', 'COO1', 'CUS1', 'CUS2', 'CUS3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SALES_PROPOSAL: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SALES_PROJECT: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SALES_TO_DO_LIST: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SALES_CONTACT_MANAGEMENT: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  SALES_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  INTRODUCER_LIST: INTRODUCER_LIST_PROFILE_CODES,
  INTRODUCER_REVENUE_LIST: ['ADM1', 'INT'],
  INTRODUCER_CLIENTS: ['ADM1', 'INT'],
  REGULATORS_LIST: REGULATORS_PROFILE_CODES,
  FINANCE_INVOICES: ['ADM1', 'CTO1', 'COO1', 'CUS1', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  FINANCE_REPORTS: ['ADM1', 'CTO1', 'COO1', 'CUS1', 'CUS3', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  FINANCE_FILE_MANAGER: ['ADM1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  FINANCE_PROJECT_PAYMENTS_REPORT: FINANCE_VIEW_PROFILE_CODES,
  PROJECTS_FINANCE: FINANCE_VIEW_PROFILE_CODES,
  HR_EMPLOYEES: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  HR_RANKING_STAFF: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  HR_APPRAISAL: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  HR_SPECIALISATION: ['ADM1', 'COO1', 'QM01', 'HRD1', 'HIT1'],
  HR_SETTINGS: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  HR_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_RISK_MANAGEMENT: QUALITY_MANAGER_RISK_MANAGEMENT_PROFILE_CODES,
  QUALITY_MANAGER_RISKS: RISK_PROFILE_CODES,
  QUALITY_MANAGER_MEETING_MINUTES: INTERNAL_PROFILE_CODES,
  QUALITY_MANAGER_SETTINGS_RISK_TIME_FRAME: RISK_PROFILE_CODES,
  QUALITY_MANAGER_RISK_MANAGEMENT_GROUP: mergeProfileCodes(
    QUALITY_MANAGER_RISK_MANAGEMENT_PROFILE_CODES,
    RISK_PROFILE_CODES,
    INTERNAL_PROFILE_CODES
  ),
  QUALITY_MANAGER_SETTINGS_GROUP: mergeProfileCodes(
    QUALITY_MANAGER_SETTINGS_PROFILE_CODES,
    RISK_PROFILE_CODES
  ),
  QUALITY_MANAGER_CAP_CORRECTIVE_ACTIONS: ['ADM1', 'CTO1', 'COO1', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_INSPECTOR_TESTER: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_MONITORING_JURISD_CHANGES: ['ADM1', 'CTO1', 'COO1', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_ACTIVITIES_PLANNING: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_COMPANY_DOCS: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  QUALITY_MANAGER_SETTINGS: QUALITY_MANAGER_SETTINGS_PROFILE_CODES,
  QUALITY_MANAGER_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  MARKETING_CAMPAIGNS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  MARKETING_HISTORY: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  MARKETING_SETTINGS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
  MARKETING_FILE_MANAGER: ['ADM1', 'QM01'],
  OFFICE_OPERATION_MISSION_TRAVELS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  OFFICE_OPERATION_RANKING_STAFF_CUSTOMERS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  OFFICE_OPERATION_TRAVEL_EXPENCES: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_CATEGORY: ['ADM1', 'CTO1', 'COO1', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_REGULATION: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_LAW: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_JURISDICTION: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_ITEMS: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_ITEM_TYPE: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_COMPANIES: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_USERS: ['ADM1', 'CTO1', 'COO1', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  GS_DEPARTMENTS: ['ADM1', 'CTO1', 'COO1', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  MANAGEMENT_FILE_MANAGER: ['ADM1', 'CTO1', 'COO1', 'DIR3', 'DIR4', 'HR3', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
  FILE_MANAGER_AUDIT: ['ADM1', 'QM01']
};

const gatewayProfileSet = new Set<ProfileCode>(GATEWAY_PROFILE_CODES);

const buildGatewayAccessMatrix = (): Record<ProfileCode, AccessKey[]> => {
  const matrix = {} as Record<ProfileCode, AccessKey[]>;

  GATEWAY_PROFILE_CODES.forEach((profileCode) => {
    matrix[profileCode] = [];
  });

  Object.entries(GATEWAY_PROFILES_BY_KEY).forEach(([key, profileCodes]) => {
    if (!profileCodes?.length) {
      return;
    }
    profileCodes.forEach((profileCode) => {
      if (!gatewayProfileSet.has(profileCode)) {
        return;
      }
      matrix[profileCode].push(key as AccessKey);
    });
  });

  return matrix;
};

export const ACCESS_MATRIX: Record<ProfileCode, AccessKey[]> = buildGatewayAccessMatrix();

export const FEATURE_ACTION_MATRIX: Record<FeatureActionKey, Partial<Record<AccessAction, ProfileCode[]>>> = {
  CLIENTS_LIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'OFF5', 'CIS1', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CCO']
  },
  CLIENTS_SETTINGS_CLIENT_TYPES: {
    view: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CCO']
  },
  REQUESTS_LIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS2', 'CUS3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO']
  },
  REQUESTS_SETTINGS_CATEGORIES: {
    view: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CCO']
  },
  PROPOSALS_LIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO']
  },
  PROPOSALS_SETTINGS_PROPOSAL_STEPS: {
    view: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['CCO']
  },
  PROPOSALS_SETTINGS_PAYMENT_TERMS: {
    view: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['CCO']
  },
  PROPOSALS_STATUS_SALES: {
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3']
  },
  PROPOSALS_STATUS_OVERDISCOUNT_APPROVAL: {
    modify: ['ADM1', 'CCO']
  },
  PROPOSALS_STATUS_TECH_APPROVAL: {
    modify: ['ADM1', 'CTO1']
  },
  PROPOSALS_STATUS_SALES_OVERALL_CHECK: {
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CCO']
  },
  PROPOSALS_STATUS_PENDING_CLIENT: {
    modify: ['ADM1', 'CTO1']
  },
  PROPOSALS_SWITCH_VERIFIED: {
    modify: ['ADM1', 'CCO']
  },
  PROPOSALS_SWITCH_VERIFIED_TECH: {
    modify: ['ADM1', 'CTO1']
  },
  PROPOSALS_DETAIL_ACTIONS: {
    modify: NON_INTRODUCER_PROFILE_CODES
  },
  PROJECTS_LIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'INT', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'PRJ6', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1'],
    export: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_SETTINGS_CHECKLIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  PROJECTS_SETTINGS_TESTLIST: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  HR_EMPLOYEES: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'QM01', 'HRD1', 'HIT1']
  },
  HR_SPECIALISATION: {
    view: ['ADM1', 'COO1', 'QM01', 'HRD1'],
    modify: ['ADM1', 'COO1', 'QM01', 'HRD1'],
    delete: ['ADM1', 'QM01', 'HRD1', 'HIT1']
  },
  MARKETING_CAMPAIGNS: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO']
  },
  GS_CATEGORY: {
    view: ['ADM1', 'CTO1', 'COO1', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_REGULATION: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_LAW: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CUS1', 'CUS2', 'CUS3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_JURISDICTION: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_ITEMS: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL3', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_ITEM_TYPE: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_USERS: {
    view: ['ADM1', 'CTO1', 'COO1', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'PRJ6', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1'],
    impersonate: ['ADM1'],
    mfaManage: ['ADM1']
  },
  GS_COMPANIES: {
    view: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  GS_DEPARTMENTS: {
    view: ['ADM1', 'CTO1', 'COO1', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CCO', 'HIT1']
  },
  INTRODUCER_LIST: {
    view: INTRODUCER_LIST_PROFILE_CODES,
    modify: INTRODUCER_LIST_EDITOR_PROFILE_CODES,
    delete: INTRODUCER_LIST_EDITOR_PROFILE_CODES
  },
  INTRODUCER_SELECT_FILTER: {
    modify: INTRODUCER_LIST_EDITOR_PROFILE_CODES
  },
  PROJECTS_CLIENTS_REQUESTED_DOCUMENTS: {
    delete: ['COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'CTO1']
  },
  CLIENTS_DETAILS_PANELS: {
    modify: INTERNAL_PROFILE_CODES
  },
  CUSTOMERS_DOCUMENTS_UPLOAD: {
    modify: NON_INTRODUCER_PROFILE_CODES
  },
  CUSTOMERS_DOCUMENTS_CONFIRMED_COLUMN: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01']
  },
  CUSTOMERS_DOCUMENTS_SEND_REMINDER: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01']
  },
  PROJECTS_SUMMARY_REVIEWED_CHECKBOX: {
    view: ['ADM1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'CTO1', 'MAN1'],
    modify: ['CTO1', 'MAT4', 'REG4', 'TES5', 'TES6']
  },
  IT_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  HR_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'QM01', 'HRD1', 'HIT1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  MANAGEMENT_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'DIR3', 'DIR4', 'HR3', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'DIR3', 'DIR4', 'HR3', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'GM01'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  FINANCE_FILE_MANAGER: {
    view: ['ADM1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CIS1', 'IT01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  SALES_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'CIS1', 'QM01', 'CCO', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CCO', 'HIT1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  TECH_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  COMPLIANCE_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'QM01', 'HIT1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'COO1', 'CEO1', 'CFO1', 'GM01'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  SHARED_RESOURCES_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL3', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'CCO', 'HIT1', 'CEO1', 'GM01'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  COMPANY_OPERATIONS_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'QM01', 'CCO', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1', 'CCO', 'CEO1', 'CFO1', 'GM01'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  QUALITY_MANAGEMENT_FILE_MANAGER: {
    view: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  MARKETING_FILE_MANAGER: {
    view: ['ADM1', 'QM01'],
    delete: ['ADM1', 'CTO1'],
    createFolder: FILE_MANAGER_CREATE_FOLDER_PROFILE_CODES
  },
  PROJECTS_TESTLIST_MODIFY: {
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'PRJ6', 'CIS1', 'IT01', 'CCO', 'HIT1', 'HMT1', 'CEO1', 'CFO1', 'GM01']
  },
  PROJECTS_TESTLIST_REVIEW_CHECKBOX: {
    modify: ['ADM1','CTO1', 'COO1', 'COM4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2']
  },
  PROJECTS_CERTIFICATE_ACTIVE_TOGGLE: {
    modify: ['ADM1', 'CTO1', 'COO1', 'SAL1', 'SAL2', 'SAL3', 'TES1', 'TES2', 'TES3', 'SOF3', 'MAT1', 'COM4', 'SOF4', 'MAT4', 'REG4', 'TES5', 'TES6', 'MAN1', 'MAN2', 'DIR3', 'DIR4', 'TE6+', 'AUD1', 'AUD2', 'AUD3', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'CCO', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01']
  },
  PROJECTS_CERTIFICATE_UPLOAD: {
    view: NON_CUSTOMER_PROFILE_CODES,
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_CERTIFICATE_HASH_CODE: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_CERTIFICATE_INACTIVE_TABLE: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_CERTIFICATE_MANAGE_ROW: {
    modify: INTERNAL_PROFILE_CODES,
    delete: INTERNAL_PROFILE_CODES
  },
  PROJECTS_TEAM_SEND_APPROVAL: {
    modify: ['ADM1', 'CTO1', 'COO1', 'COM4', 'SOF4', 'MAT4', 'REG4']
  },
  PROJECTS_TAB_SUMMARY: {
    view: [...CUSTOMER_PROFILE_CODES, INTRODUCER_PROFILE_CODE]
  },
  PROJECTS_TAB_DOCUMENTS_REQUESTED_TO_CLIENT: {
    view: CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TAB_TEAM: {
    view: CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TAB_TESTLIST: {
    view: CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TAB_ISSUES: {
    view: CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TAB_CERTIFICATE: {
    view: CUSTOMER_PROFILE_CODES
  },
  PROJECTS_SUMMARY_INSPECTORS: {
    view: NON_CUSTOMER_PROFILE_CODES,
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_SUMMARY_NOTES: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_SUMMARY_FIELDS_EDIT: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_SUMMARY_PROGRESS_NOTE: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_CLIENTS_REQUESTED_DOCUMENTS_CREATE: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_CLIENTS_REQUESTED_DOCUMENTS_SEND_REQUEST: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_TEAM_AVAILABLE_STAFF: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TEAM_ASSIGNMENT_EDIT: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_TEAM_MOOD_BUTTON: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_TESTLIST_REVIEW_CHECKBOX_CONFIRM: {
    view: NON_CUSTOMER_PROFILE_CODES
  },
  PROJECTS_TESTLIST_EVIDENCE_UPLOAD: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_TESTLIST_ROUND_FULL_ACCESS: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_ISSUES_DELETE: {
    delete: INTERNAL_PROFILE_CODES
  },
  PROJECTS_ISSUES_VERIFIED_CHECKBOX: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_ISSUES_STATUS_EDIT: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_ISSUES_PRIORITY_EDIT: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_ACCORDION_SAVE_BUTTON: {
    modify: INTERNAL_PROFILE_CODES
  },
  PROJECTS_FINANCE: {
    view: FINANCE_VIEW_PROFILE_CODES,
    modify: FINANCE_MANAGE_PROFILE_CODES,
    delete: FINANCE_MANAGE_PROFILE_CODES
  },
  FINANCE_PROJECT_PAYMENTS_REPORT: {
    view: FINANCE_VIEW_PROFILE_CODES
  },
  REGULATORS_LIST: {
    view: REGULATORS_PROFILE_CODES,
    modify: REGULATORS_MANAGE_PROFILE_CODES,
    delete: REGULATORS_MANAGE_PROFILE_CODES
  },
  QUALITY_MANAGEMENT_ACTIVITIES_PLANNING: {
    view: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'SEC1', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    modify: ['ADM1', 'CTO1', 'COO1', 'HR1', 'HR2', 'HR3', 'OFF4', 'OFF5', 'PRJ6', 'CIS1', 'IT01', 'QM01', 'HRD1', 'HIT1', 'HMT1', 'HRA1', 'CEO1', 'CFO1', 'GM01'],
    delete: ['ADM1']
  },
  QUALITY_MANAGEMENT_COMPANY_DOCUMENTS: {
    view: INTERNAL_PROFILE_CODES,
    modify: INTERNAL_PROFILE_CODES,
    delete: ['ADM1', 'QM01']
  },
  QUALITY_MANAGEMENT_SETTINGS_DOCUMENT_GROUPS: {
    view: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01', 'PRJ6'],
    modify: ['ADM1', 'CTO1', 'COO1', 'CIS1', 'IT01', 'QM01', 'HIT1', 'HRA1', 'CEO1', 'CFO1', 'GM01', 'PRJ6'],
    delete: ['ADM1', 'QM01']
  },
  QUALITY_MANAGEMENT_RISKS: {
    view: RISK_PROFILE_CODES,
    modify: RISK_PROFILE_CODES,
    delete: RISK_PROFILE_CODES
  },
  QUALITY_MANAGEMENT_MEETING_MINUTES: {
    view: INTERNAL_PROFILE_CODES,
    modify: INTERNAL_PROFILE_CODES,
    delete: ['ADM1', 'QM01']
  },
  QUALITY_MANAGEMENT_SETTINGS_RISK_TIME_FRAMES: {
    view: RISK_PROFILE_CODES,
    modify: ['ADM1', 'QM01'],
    delete: ['ADM1', 'QM01']
  },
};

const isProfileCode = (value: string): value is ProfileCode => {
  return Object.prototype.hasOwnProperty.call(ACCESS_MATRIX, value);
};

export const normalizeProfileCode = (value: string | null | undefined): ProfileCode | null => {
  if (!value) {
    return null;
  }
  const normalized = value.trim().toUpperCase().replace(/[\s-]+/g, '_');
  if (isProfileCode(normalized)) {
    return normalized;
  }

  if (Object.prototype.hasOwnProperty.call(LEGACY_PROFILE_TO_GATEWAY, normalized)) {
    return LEGACY_PROFILE_TO_GATEWAY[normalized];
  }

  const plusNormalized = normalized.replace('_PLUS', '+');
  if (isProfileCode(plusNormalized)) {
    return plusNormalized;
  }

  return null;
};
